// 用户备考意向接口
import ajax from '@/utils/ajax';

const header = '/web';

// 获取备考意向列表
// export const chooseRecordsList = () => ajax(`${header}/v1/user/exam/choose-records/list`);

export const chooseRecordsList = () => ajax(`${header}/v1/label-tree/new/list`);

// 保存用户备考信息列表
// export const saveChooseRecords = (data) => ajax(`${header}/v1/user/exam/choose-records/save`, data, 'POST');
export const saveChooseRecords = (data) => ajax(`${header}/v1/label-tree`, data, 'POST');


